module.exports = __webpack_public_path__ + "img/Icon-3.fc40955a.png";